import React from 'react';
import { FaWrench, FaDollarSign, FaTruck, FaShieldAlt, FaSearchPlus, FaMedal } from 'react-icons/fa';
import './Features.css';

const features = [
  {
    icon: <FaWrench />,
    color: '#ff5c00',
    title: 'Genuine OEM Quality',
    desc: 'Every part meets or exceeds OEM specs — sourced direct from manufacturers and certified suppliers.',
  },
  {
    icon: <FaDollarSign />,
    color: '#10b981',
    title: 'Up to 30% Less',
    desc: 'We eliminate the middleman. Direct sourcing means real savings passed straight to you.',
  },
  {
    icon: <FaTruck />,
    color: '#0ea5e9',
    title: 'Same-Day Dispatch',
    desc: 'Order before 2PM EST and we dispatch the same day. Free shipping on orders over $100.',
  },
  {
    icon: <FaShieldAlt />,
    color: '#8b5cf6',
    title: '90-Day Warranty',
    desc: 'Every single part ships with our comprehensive 90-day warranty. No questions asked.',
  },
  {
    icon: <FaSearchPlus />,
    color: '#f59e0b',
    title: 'VIN Fitment Check',
    desc: 'Our specialists verify fitment against your exact VIN before dispatch — right part, every time.',
  },
  {
    icon: <FaMedal />,
    color: '#ec4899',
    title: 'Trusted Since 2005',
    desc: '20+ years serving repair shops, fleet managers, and DIY mechanics with award-winning service.',
  },
];

const Features = () => (
  <section className="features-sec" id="about">
    <div className="container">
      <div className="section-header-center">
        <div className="section-label">WHY MAXAUTOPARTS</div>
        <h2 className="section-title">Everything You Need<br />in One Parts Platform</h2>
        <p className="section-desc">
          Nodex Global built MaxAutoParts from the ground up to solve every friction
          point in buying auto parts — price, fitment, speed, and trust.
        </p>
      </div>

      <div className="features-grid">
        {features.map((f, i) => (
          <div className="feature-card" key={i} style={{ '--clr': f.color }}>
            <div className="fc-icon-wrap">
              {f.icon}
            </div>
            <h3>{f.title}</h3>
            <p>{f.desc}</p>
            <div className="fc-line" />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Features;
